export default __webpack_public_path__ + "static/media/logo.7f405a90.svg";